import { render, staticRenderFns } from "./media-browser.vue?vue&type=template&id=05a1055b&scoped=true&"
import script from "./media-browser.vue?vue&type=script&lang=js&"
export * from "./media-browser.vue?vue&type=script&lang=js&"
import style0 from "./media-browser.vue?vue&type=style&index=0&id=05a1055b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a1055b",
  null
  
)

export default component.exports